
import Vue from 'vue';

interface Props {
  page: string;
}

interface Methods {
  setActivePage: (page: string) => void;
}
export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  methods: {
    setActivePage(page) {
      this.$emit('set-active-page', page);
    },
  },
});
